import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { hookFormZod } from '@ipfabric/ui-components/utils/hookForm/hookFormZod';
import { retryAuth } from '@ipfabric/utils';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export type AuthenticationFailureFieldValues = { cliRetryAuthFailure: string };
export type AuthenticationFailureOutputValues = { cliRetryAuthFailure: number };

export const authenticationFailure: FormSnippet<
  DiscoverySettingsObject,
  AuthenticationFailureFieldValues,
  AuthenticationFailureOutputValues
> = {
  render: ({ form }) => (
    <FormTextField
      control={form.control}
      type='number'
      name='cliRetryAuthFailure'
      description='Number of retries after an authentication failure.'
      label='Authentication failure'
      endAdornment='retries'
      inputWidthClassName='w-60'
    />
  ), // Placeholder for the actual component
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.cliRetryAuthFailure =
      model.cliRetryLimit?.authFail?.toString() ?? '';
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.cliRetryLimit ??= {};
    modelDraft.cliRetryLimit.authFail = transformedValues.cliRetryAuthFailure;
  },
  schema: z.object({
    cliRetryAuthFailure: hookFormZod.numberInputWith(
      hookFormZod.minMax(retryAuth.min, retryAuth.max),
    ),
  }),
};
